export const useGoBack = (fallbackPath: string) => {
  const router = useRouter()
  const { $normalizePath } = useNuxtApp()

  const goBack = () => {
    const normalizedFallbackPath = $normalizePath(fallbackPath)

    const { position } = router.options.history.state
    if (position === 1) {
      return navigateTo(normalizedFallbackPath)
    }

    return router.back()
  }

  return {
    goBack
  }
}
